export const inter = `'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif`;
export const fontFamily = {
    default: inter,
};
export const fontSize = {
    display: '1.5rem',
    huge: '1.25rem',
    large: '1rem',
    medium: '0.875rem',
    small: '0.75rem',
    tiny: '0.6875rem',
    /** 9px — icon glyphs, chip dots and badge counts only. Never for prose. */
    micro: '0.5625rem',
};
export const fontWeight = {
    regular: '400',
    medium: '500',
    semibold: '600',
};
export const fontStyle = {
    normal: 'normal',
    italic: 'italic',
};
export const lineHeight = {
    default: '140%',
    neutralized: '120%',
    none: '1',
};
const role = (weight, size, height) => `${weight} ${size}/${height} ${inter}`;
/**
 * Role composites — size, weight and line-height bundled into a single `font`
 * shorthand, so a component states its text role once instead of re-declaring
 * the three properties:
 * ```
 * font: ${theme.fontRole.body};
 * ```
 */
export const fontRole = {
    display: role(fontWeight.semibold, fontSize.display, lineHeight.neutralized),
    heading: role(fontWeight.semibold, fontSize.huge, lineHeight.neutralized),
    title: role(fontWeight.medium, fontSize.large, lineHeight.neutralized),
    body: role(fontWeight.regular, fontSize.medium, lineHeight.default),
    bodyEm: role(fontWeight.medium, fontSize.medium, lineHeight.neutralized),
    bodySm: role(fontWeight.regular, fontSize.small, lineHeight.default),
    label: role(fontWeight.medium, fontSize.small, lineHeight.neutralized),
    caption: role(fontWeight.regular, fontSize.tiny, lineHeight.neutralized),
};
